<template>
  <div>
    <p>
      Auf wieder sehen
    </p>
  </div>
</template>

<script>
    export default {
      name: 'SignOut'
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auth/SignOut.vue